import React from 'react'
import { Button } from '@material-ui/core'
import '../buttonstyles.scss'
var classNames = require('classnames')

export const TextButton = ({ endIcon, text, withBorder, underline, startIcon, className, ...props }) => {
  return (
    <Button
      variant="text"
      endIcon={endIcon}
      startIcon={startIcon}
      color="primary"
      className={classNames('no-text-transform', { 'with-blue-border': withBorder }, { underline: underline }, className)}
      {...props}
    >
      {text}
    </Button>
  )
}
